// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__TzfrK","logo":"Toolbar_logo__ZKOY0","logoHorizontal":"Toolbar_logoHorizontal__lF9FL"};